import React, {Component, Fragment} from 'react';
import {withTranslation} from "react-i18next";
import {Helmet} from "react-helmet";
import {HeroBlock, GelContentContainer, Accordion, GelContentRow, GelContentColumn, List, Link, RegularCard, withAuthentication, Role, Loading} from "cw-styleguide-react";
import {route} from "../../../routes";
import {
  STATUS_NEW,
  STATUS_AWAITING_TRANSLATION,
  STATUS_EDITED,
  STATUS_AWAITING_AMENDMENTS, ROLE_STAFF, ROLE_PROVIDER, LANGUAGE_EN,
} from "../../../constants";
import i18n from "../../../i18n";
class LandingView extends Component {
  render() {


    return (
      <Fragment>
        <Helmet>
          <title>{this.props.t('view.landing.title')}</title>
        </Helmet>
        <HeroBlock title={this.props.t('view.landing.title')}>
          <Role roles={[ROLE_STAFF]}>
            {this.props.t('view.landing.introduction.staff')}
          </Role>
          <Role roles={[ROLE_PROVIDER]}>
            {this.props.t('view.landing.introduction.provider')}
          </Role>

        </HeroBlock>
        <GelContentContainer>




          { (this.props.summaryLoaded && this.props.reviewLoaded ) && <Fragment>



          {/* Careers Wales Staff */}
          <Role roles={[ROLE_STAFF]}>
            <Fragment>
              <h2>{this.props.t('view.landing.subheading.qualityAuditPending')}</h2>
              <GelContentRow>
                <GelContentColumn md={6}>
                  <h3>{this.props.t('view.landing.subheading.new')} ({this.props.summary.courses[STATUS_NEW] +  this.props.summary.venues[STATUS_NEW] + this.props.summary.contacts[STATUS_NEW]})</h3>
                  <List styles={['list-large']} items={[
                    <Link to={route('courses')+ "?courseStatus=" +  STATUS_NEW}>{this.props.t('misc.courses')} ({this.props.summary.courses[STATUS_NEW]})</Link>,
                    <Link to={route('venuesManage')+ "?status=" +  STATUS_NEW}>{this.props.t('misc.venues')} ({this.props.summary.venues[STATUS_NEW]})</Link>,
                    <Link to={route('contactsManage')+ "?status=" +  STATUS_NEW}>{this.props.t('misc.contacts')} ({this.props.summary.contacts[STATUS_NEW]})</Link>
                  ]}/>
                </GelContentColumn>
                <GelContentColumn md={6}>
                  <h3>{this.props.t('view.landing.subheading.edited')} ({this.props.summary.courses[STATUS_EDITED] +  this.props.summary.venues[STATUS_EDITED] + this.props.summary.contacts[STATUS_EDITED]})</h3>
                  <List styles={['list-large']} items={[
                    <Link to={route('courses')+ "?courseStatus=" +  STATUS_EDITED}>{this.props.t('misc.courses')} ({this.props.summary.courses[STATUS_EDITED]})</Link>,
                    <Link to={route('venuesManage')+ "?status=" +  STATUS_EDITED}>{this.props.t('misc.venues')} ({this.props.summary.venues[STATUS_EDITED]})</Link>,
                    <Link to={route('contactsManage')+ "?status=" +  STATUS_EDITED}>{this.props.t('misc.contacts')} ({this.props.summary.contacts[STATUS_EDITED]})</Link>
                  ]}/>
                </GelContentColumn>
              </GelContentRow>

            </Fragment>
          </Role>

          {/* Training Providers */}
          <Role roles={[ROLE_PROVIDER]}>
            <Fragment>
              <h2>{this.props.t('view.landing.subheading.coursesStatus')}</h2>
              <GelContentRow>
                <GelContentColumn md={6}>
                  <h3>{this.props.t('view.landing.subheading.awaitingQualityAuditNew')} ({this.props.summary.courses[STATUS_NEW] +  this.props.summary.venues[STATUS_NEW] + this.props.summary.contacts[STATUS_NEW]})</h3>
                  <List styles={['list-large']} items={[
                    <Link to={route('courses')  + "?courseStatus=" +  STATUS_NEW}>{this.props.t('misc.courses')} ({this.props.summary.courses[STATUS_NEW] })</Link>,
                    <Link to={route('venuesManage')  + "?status=" +  STATUS_NEW}>{this.props.t('misc.venues')} ({this.props.summary.venues[STATUS_NEW]})</Link>,
                    <Link to={route('contactsManage')  + "?status=" +  STATUS_NEW}>{this.props.t('misc.contacts')} ({this.props.summary.contacts[STATUS_NEW]})</Link>
                  ]}/>
                </GelContentColumn>
                <GelContentColumn md={6}>
                  <h3>{this.props.t('view.landing.subheading.awaitingQualityAuditEdited')} ({this.props.summary.courses[STATUS_EDITED] +  this.props.summary.venues[STATUS_EDITED] + this.props.summary.contacts[STATUS_EDITED]})</h3>
                  <List styles={['list-large']} items={[
                    <Link to={route('courses')+ "?courseStatus=" +  STATUS_EDITED}>{this.props.t('misc.courses')} ({this.props.summary.courses[STATUS_EDITED]})</Link>,
                    <Link to={route('venuesManage')+ "?status=" +  STATUS_EDITED}>{this.props.t('misc.venues')} ({this.props.summary.venues[STATUS_EDITED]})</Link>,
                    <Link to={route('contactsManage')+ "?status=" +  STATUS_EDITED}>{this.props.t('misc.contacts')} ({this.props.summary.contacts[STATUS_EDITED]})</Link>
                  ]}/>
                </GelContentColumn>

                <GelContentColumn md={6}>
                  <h3>{this.props.t('view.landing.subheading.awaitingTranslationNew')} ({this.props.summary.courses[STATUS_AWAITING_TRANSLATION] +  this.props.summary.venues[STATUS_AWAITING_TRANSLATION] })</h3>
                  <List styles={['list-large']} items={[
                    <Link to={route('courses')+ "?courseStatus=" +  STATUS_AWAITING_TRANSLATION}>{this.props.t('misc.courses')} ({this.props.summary.courses[STATUS_AWAITING_TRANSLATION]})</Link>,
                    <Link to={route('venuesManage')+ "?status=" +  STATUS_AWAITING_TRANSLATION}>{this.props.t('misc.venues')} ({this.props.summary.venues[STATUS_AWAITING_TRANSLATION]})</Link>,

                  ]}/>
                </GelContentColumn>

                <GelContentColumn md={6}>
                  <h3>{this.props.t('view.landing.subheading.awaitingTranslationEdited')} ({this.props.summary.courses[STATUS_AWAITING_AMENDMENTS] +  this.props.summary.venues[STATUS_AWAITING_AMENDMENTS] })</h3>
                  <List styles={['list-large']} items={[
                    <Link to={route('courses')+ "?courseStatus=" +  STATUS_AWAITING_AMENDMENTS}>{this.props.t('misc.courses')} ({this.props.summary.courses[STATUS_AWAITING_AMENDMENTS]})</Link>,
                    <Link to={route('venuesManage')+ "?status=" +  STATUS_AWAITING_AMENDMENTS}>{this.props.t('misc.venues')} ({this.props.summary.venues[STATUS_AWAITING_AMENDMENTS]})</Link>,

                  ]}/>
                </GelContentColumn>
              </GelContentRow>

            </Fragment>
          </Role>

          {this.props.reviewItems.length > 0 &&
            <Fragment><h2 className={'gel-xs-mb-0'} >{this.props.t('view.landing.subheading.review')}</h2>
            <div className={'gel-xs-mb-40'}><Accordion items={this.props.reviewItems}/></div></Fragment>}

          </Fragment>}


          {(!this.props.summaryLoaded || !this.props.reviewLoaded ) && <Loading text={this.props.t('local:view.landing.messages.loadingSummary')} inline={true}/>}



          <GelContentRow>
            <RegularCard width={33} link={{to: route('courses') }} title={this.props.t('view.courses.manage.title')} source={'https://cwimagestorage.blob.core.windows.net/courses/prod/images/thumbnail_courses_manage_courses.jpg'} alt={this.props.t('view.courses.manage.title')}>
              <Role roles={[ROLE_STAFF]}>
                {this.props.t('view.courses.manage.teaser.staff')}
              </Role>
              <Role roles={[ROLE_PROVIDER]}>
                {this.props.t('view.courses.manage.teaser.provider')}
              </Role>
            </RegularCard>
            <RegularCard width={33} link={{to: route('venuesManage')}} title={this.props.t('view.venues.manage.title')} source={'https://cwimagestorage.blob.core.windows.net/courses/prod/images/thumbnail_courses_manage_venues.jpg'} alt={this.props.t('view.venues.manage.title')}>
              <Role roles={[ROLE_STAFF]}>
                {this.props.t('view.venues.manage.teaser.staff')}
              </Role>
              <Role roles={[ROLE_PROVIDER]}>
                {this.props.t('view.venues.manage.teaser.provider')}
              </Role>
            </RegularCard>
            <RegularCard width={33} link={{to: route('contactsManage')}} title={this.props.t('view.contacts.manage.title')} source={'https://cwimagestorage.blob.core.windows.net/courses/prod/images/thumbnail_courses_manage_contacts.jpg'} alt={this.props.t('view.contacts.manage.title')}>
              <Role roles={[ROLE_STAFF]}>
                {this.props.t('view.contacts.manage.teaser.staff')}
              </Role>
              <Role roles={[ROLE_PROVIDER]}>
                {this.props.t('view.contacts.manage.teaser.provider')}
              </Role>
            </RegularCard>
          </GelContentRow>
          <GelContentRow>
            <RegularCard width={33} link={{to: route('courseGroupsManage')}} title={this.props.t('view.courseGroups.manage.title')} source={'https://cwimagestorage.blob.core.windows.net/courses/prod/images/thumbnail_courses_manage_course_groups.jpg'} alt={this.props.t('view.courseGroups.manage.title')}>
              <Role roles={[ROLE_STAFF]}>
                {this.props.t('view.courseGroups.manage.teaser.staff')}
              </Role>
              <Role roles={[ROLE_PROVIDER]}>
                {this.props.t('view.courseGroups.manage.teaser.provider')}
              </Role>
            </RegularCard>

            <Role roles={[ROLE_STAFF]}>
              <RegularCard width={33} link={{to: process.env.REACT_APP_COURSES_PORTAL_DYNAMICS}} title={this.props.t('view.providers.manage.title')} source={'https://cwimagestorage.blob.core.windows.net/courses/prod/images/thumbnail_courses_manage_providers.jpg'} alt={this.props.t('view.providers.manage.title')}>
               {this.props.t('view.providers.manage.teaser')}
              </RegularCard>
            </Role>

              <RegularCard width={33} link={{to: (i18n.language === LANGUAGE_EN ? process.env.REACT_APP_BASEURL_EN : process.env.REACT_APP_BASEURL_CY ) + this.props.t('view.support.manage.url')}} title={this.props.t('view.support.manage.title')} source={'https://cwimagestorage.blob.core.windows.net/courses/prod/images/thumbnail_courses_courses_support_centre.jpg'} alt={this.props.t('view.providers.support.title')}>
                {this.props.t('view.support.manage.teaser')}
              </RegularCard>

          </GelContentRow>
        </GelContentContainer>
      </Fragment>
    );
  }
}

export default withAuthentication(withTranslation('local')(LandingView));
